import { MealIngredient } from './ingredient';
import { Tag } from './tag';

type Meal = {
  id: string;
  name: string;
  image: string;
  imageThumbnail: string | null;
  description: string;
  lastCooking: Date | null;
  averageCookingDate: Date | null;
  cookingCount: number;
  tastiness: number | null;
  healthiness: number | null;
  servings: number | null;
  calories: number | null;
  protein: number | null;
  carbs: number | null;
  fat: number | null;
  preparationTime: number | null;
  ingredients: MealIngredient[];
  tags: Tag[];
};

export interface FilteredMeal extends Meal {
  matchedCount: number;
  totalIngredientCount: number;
}

export const mapMealFromApi = (meal: any): Meal => ({
  id: meal.id,
  name: meal.name,
  image: meal.image,
  imageThumbnail: meal.imageThumbnail ?? null,
  description: meal.description,
  lastCooking: meal.lastCooking ? new Date(meal.lastCooking * 1000) : null,
  averageCookingDate: meal.averageCookingDate ? new Date(meal.averageCookingDate * 1000) : null,
  cookingCount: meal.mealCookingCount ?? 0,
  tastiness: meal.tastiness ?? null,
  healthiness: meal.healthiness ?? null,
  servings: meal.servings ?? null,
  calories: meal.calories ?? null,
  protein: meal.protein ?? null,
  carbs: meal.carbs ?? null,
  fat: meal.fat ?? null,
  preparationTime: meal.preparationTime ?? null,
  ingredients: meal.ingredients ?? [],
  tags: meal.tags ?? [],
});

export default Meal;
